import React from "react";
import { connect } from "react-redux";
import { PageDisplay, Pages, SubPageDisplay, SubPages } from "../../../../../../../store/AppDisplays";
import { isRemoteLoading, ReduxState } from "../../../../../../../store/ReduxState";
import { RemoteScope } from "../../../../../../../store/RemoteTypes";
import { Filter } from "../../../../02-pages/Filter";
import { Results } from "../../../../02-pages/Results";
import { Page } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Page";
import { Header } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Header";
import { CollectiveInvoices } from "../../../../../../../store/CollectiveInvoice/Types";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";

/**
 *
 */
interface StateProps {
    loadingFilters: boolean;
    loadingResults: boolean;
    results: CollectiveInvoices;
}

type Props = StateProps;

/**
 *
 * @param s
 */
const mapStateToProps = (s: ReduxState): StateProps => ({
    loadingFilters: false,
    loadingResults: isRemoteLoading(s, RemoteScope.COLLECTIVE_INVOICE_RESULTS),
    results: s.prop("remote").prop(RemoteScope.COLLECTIVE_INVOICE_RESULTS),
});

/**
 *
 * @param props
 */
export class CIAuditTrailComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props) {
        super(props);
    }

    public render() {
        return (
            <Page>
                <Container
                    theme={{
                        padding: {
                            "": { y: 3 },
                            "sm": { y: 4 },
                        },
                    }}
                >
                    <Header
                        title={SubPageDisplay[SubPages.AUDIT_TRAIL_CI].title}
                        description={SubPageDisplay[SubPages.AUDIT_TRAIL_CI].description}
                        goBack={PageDisplay[Pages.AUDIT_TRAILS].path}
                    />
                    <Filter
                        loadingFilters={this.props.loadingFilters}
                        loadingResults={this.props.loadingResults}
                        currentPage={Pages.COLLECTIVEINVOICES}
                    />
                    <Results
                        results={this.props.results}
                        loadingResults={this.props.loadingResults}
                        currentPage={SubPages.AUDIT_TRAIL_CI}
                        scope={RemoteScope.COLLECTIVE_INVOICE_RESULTS}
                    />
                </Container>
            </Page>
        );
    }
}

/**
 *
 */
export const CIAuditTrail = connect(
    mapStateToProps,
    {},
)(CIAuditTrailComp);
